(function () {
  angular.module("akitabox.ui.dialogs.schedule.cancel", [
    "akitabox.core.constants",
    "akitabox.core.services.schedule",
    "akitabox.core.toast",
  ]);
})();
